// Steps describe a metric, not each of its evidence sources.
export function explorationSteps(state, en = false) {
  const t = (de, eng) => (en ? eng : de);
  const common = [
    ["strength", null, t("Spielstärke", "Strength")],
    ["goals", null, t("Torniveau", "Goal level")],
    ["strength", "for_total", t("Offensive", "Attack")],
    ["strength", "against_total", t("Defensive", "Defence")],
    ["strength", "for_home", t("Heim-Offensive", "Home attack")],
    ["strength", "against_home", t("Heim-Defensive", "Home defence")],
    ["strength", "for_away", t("Auswärts-Offensive", "Away attack")],
    ["strength", "against_away", t("Auswärts-Defensive", "Away defence")],
    ["home", null, t("Heimvorteil", "Home advantage")],
    ["draws", null, t("Unentschieden-Faktor", "Draw factor")],
  ];
  const result = ["result", "statistics"].flatMap((model) =>
    common.map(([question, field, title]) => ({
      id: `${model}:${field || question}`,
      model,
      question,
      field,
      title,
    }))
  );
  for (const [key, weight] of Object.entries(state?.weights || {})) {
    if (!Number.isFinite(weight) || weight === 0) continue;
    result.push({
      id: `stat:${key}`,
      model: "statistics",
      question: "statistics",
      statistic: key,
      title: state.registry?.[key]?.title || key,
    });
  }
  result.push({
    id: "conversion",
    model: "statistics",
    question: "statistics",
    statistic: "conversion",
    title: "Conversion Rate",
  });
  return result;
}
export function bundesliga(leagues) {
  return (
    leagues.find((l) => Number(l.id) === 82) ||
    leagues.find(
      (l) =>
        l.name === "Bundesliga" &&
        /germany|deutschland/i.test(l.country?.name || "")
    )
  );
}
